import React, { useEffect, useState } from "react";
import { Download, Images, X } from "lucide-react";
import api from "@/lib/api";

const toUrl = (p) => `${process.env.REACT_APP_BACKEND_URL}${p}`;

export default function PupRecaps() {
  const [recaps, setRecaps] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/pup/recaps").then(({ data }) => setRecaps(data.recaps || [])).catch(() => {}); }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);
  if (recaps.length === 0) return null;
  return (
    <div className="bg-white rounded-3xl soft-shadow p-5" data-testid="pup-recaps">
      <h3 className="font-display font-extrabold text-lg text-[#19324A] mb-1 inline-flex items-center gap-2"><Images className="w-5 h-5 text-[#FF6B9D]" /> Monthly recaps</h3>
      <p className="text-xs text-[#19324A]/55 mb-3">Every pup who entered, month by month. Tap to see it big or download to share.</p>
      <div className="flex gap-3 overflow-x-auto pb-1">
        {recaps.map((r) => (
          <div key={r.month} className="shrink-0 w-40" data-testid={`pup-recap-${r.month}`}>
            <button type="button" onClick={() => setOpen(r)} className="block w-40 h-40 rounded-2xl overflow-hidden border-2 border-[#FFD93D] hover:scale-[1.03] transition-transform" data-testid={`pup-recap-open-${r.month}`}>
              <img src={toUrl(r.image)} alt={`${r.month_label} recap`} className="w-full h-full object-cover" loading="lazy" />
            </button>
            <p className="text-xs font-bold text-[#19324A] mt-1.5">{r.month_label}</p>
            <p className="text-[10px] text-[#19324A]/50">{r.entries} {r.entries === 1 ? "pup" : "pups"} · {r.winner_name} crowned</p>
          </div>
        ))}
      </div>
      {open && (
        <div className="fixed inset-0 z-[80] bg-[#19324A]/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(null)} data-testid="pup-recap-lightbox">
          <div className="relative max-w-[min(92vw,640px)] w-full" onClick={(e) => e.stopPropagation()}>
            <button type="button" onClick={() => setOpen(null)} aria-label="Close" className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-white text-[#19324A] inline-flex items-center justify-center soft-shadow" data-testid="pup-recap-close"><X className="w-4 h-4" /></button>
            <img src={toUrl(open.image)} alt={`${open.month_label} recap`} className="w-full rounded-2xl" />
            <div className="mt-3 flex items-center justify-between gap-3">
              <p className="text-sm font-bold" style={{ color: "#fff" }}>{open.month_label} · {open.entries} {open.entries === 1 ? "pup" : "pups"} · {open.winner_name} crowned</p>
              <a href={toUrl(open.image)} download={`pup-of-the-month-recap-${open.month}.png`} className="inline-flex items-center gap-1.5 rounded-full bg-[#FFD93D] text-[#19324A] text-sm font-bold px-4 py-2" data-testid="pup-recap-lightbox-download"><Download className="w-4 h-4" /> Download</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
